import { getCookie } from '@Utils/cookies';

import { Cookies, DEFAULT_LANG } from './constants';

export function getDefaultLanguage() {
  const cookieLanguage = getCookie(Cookies.defaultLang);
  return cookieLanguage || DEFAULT_LANG;
}
